const baseUrl = process.env.VUE_APP_BaseUrl;
const userPath = baseUrl + 'ebook/res/user/';
const purchasePath = baseUrl + 'ebook/res/purchase/';
const teaResource = baseUrl + 'ebook/teacher/newTeaResource/';

const config = {
  exportBehaviorExcel:
    baseUrl + 'ebook/teacher/statistics/statisticsClassExport',

  exportRelationExcel: baseUrl + 'ebook/teacher/statistics/relationExport',
  exportExcel: baseUrl + 'ebook/teacher/statistics2Export/exportExcel',
  exportUserRelationship: baseUrl + 'ebook/teacher/statistics2Export/exportUserRelationship',

  getMyClassInfo: baseUrl + 'ebook/class/common/getMyClassInfo',

  getStudentTaskPage: baseUrl + 'ebook/teacher/task/getStudentTaskPage',

  getGroupTaskPage: baseUrl + 'ebook/teacher/task/getGroupTaskPage',

  // 获取老师所在的班级列表
  getTeaClassListByUserId:
    baseUrl + 'ebook/class/v3/common/getClaList',

  // 获取教材课程级联列表
  getBookStyleTierList:
    baseUrl + 'ebook/teacher/task/correct/getBookStyleTierList',

  // 分页获取学生个人作业任务列表
  getTeaPersonTaskHomeWorks:
    baseUrl + 'ebook/teacher/task/correct/getTeaPersonTaskHomeWorks',

  // 分页获取学生小组作业任务列表
  getTeaGroupTaskHomeWorks:
    baseUrl + 'ebook/teacher/task/correct/getTeaGroupTaskHomeWorks',

  // 根据班级Id 任务id 获取班级下学生列表及学生任务批改状态
  listClassStudentsAndTaskCorrectStatus:
    baseUrl +
    'ebook/teacher/task/correct/listClassStudentsAndTaskCorrectStatus',

  // 根据班级Id 任务id 获取班级下小组列表及任务批改状态
  listClassGroupAndTaskCorrectStatus:
    baseUrl + 'ebook/teacher/task/correct/listClassGroupAndTaskCorrectStatus',

  // 根据班级Id 任务id 学生用户id(或者小组组长的用户id) 获取班级下学生任务活动详情及批改
  getStudentTaskActivityDetailsCorrectInfo:
    baseUrl +
    'ebook/teacher/task/correct/getStudentTaskActivityDetailsCorrectInfo',

  // 教师任务提交批改
  submitTaskCorrect: baseUrl + 'ebook/teacher/task/correct/submitTaskCorrect',

  // 教师任务批改任务打回重做
  userTaskReform: baseUrl + 'ebook/teacher/task/correct/userTaskReform',

  // 教师获取任务活动批改评语列表
  getTeaCorrectReviews:
    baseUrl + 'ebook/teacher/task/correct/getTeaCorrectReviews',

  // 教师保存自定义任务活动批改评语
  saveCustomTeaTaskCorrectReviews:
    baseUrl + 'ebook/teacher/task/correct/saveCustomTeaTaskCorrectReviews',

  // 教师分页获取答题记录
  getTeaQuExam: baseUrl + 'ebook/teacher/task/correct/getTeaQuExam',

  // 教师答题记录获取答题详情
  getByIdExamUserRecord:
    baseUrl + 'ebook/teacher/task/correct/getByIdExamUserRecord',

  // 教师备课获取课文导读
  getTeacherTextGuide: baseUrl + 'ebook/teacher/study/getTeacherTextGuide',

  // 教师备课获取相关阅读
  getRelatedRead: baseUrl + 'ebook/teacher/study/getRelatedRead',

  // 根据相关阅读获取相关阅读详细内容
  getRelatedReadInfo: baseUrl + 'ebook/teacher/study/getRelatedReadInfo',
  // 蜗牛视频
  saveMediaPlayCount: baseUrl + 'ebook/teacher/live/saveMediaPlayCount',
  // 蜗牛直播
  savePlayCount: baseUrl + 'ebook/officialLive/savePlayCount',

  // 修改密码
  updateUserPwd: userPath + 'updateUserPwd',
  // 修改个人信息
  updateUserInfo: userPath + 'updateUserInfo',
  // 根据用户id 获取个人信息
  getUserInfoByUserId: userPath + 'getUserInfoByUserId',
  // 用户购买开通是否有效
  isPurchase: purchasePath + 'isPurchase',
  // 获取产品列表
  getProducts: purchasePath + 'getProducts',
  // 获取我的教材列表
  listPageBuyBook: 'ebook/res/listPageBuyBook',
  // 个人中心我的订单列表
  webListOrder: purchasePath + 'webListOrder',
  // 个人中心列表取消订单
  webCancelOrder: purchasePath + 'webCancelOrder',
  // 获取产品列表
  webPurchaseSubmitOrder: purchasePath + 'webPurchaseSubmitOrder',

  // #region 文件夹模块
  // 获取文件夹列表
  getDirList: teaResource + 'getDirList',
  // 获取文件列表
  getFilePage: teaResource + 'getFilePage',
  // 文件重命名
  rename: teaResource + 'rename',
  // 创建文件夹
  createDir: teaResource + 'createDir',
  // 文件共享
  share: teaResource + 'share',
  // 移动文件
  moveFile: teaResource + 'moveFile',
  // 删除文件
  deleteFile: teaResource + 'deleteFile',
  // 上传文件
  uploadFile: teaResource + 'uploadFileSuccessCallBack',
  // getSharePage
  getSharePage: teaResource + 'getSharePage',
  // cancelShare
  cancelShare: teaResource + 'cancelShare',
  // #endregion

  // 根据资源id 更新资源的 浏览量或者下载量
  updateTeaResourceViewOrDownLoadCount:
    baseUrl +
    'ebook/teacher/newTeaResource/updateTeaResourceViewOrDownLoadCount',

  // #region 群聊 环信模块
  // 获取环信用户id和密码
  registerOrGetImUser: baseUrl + 'ebook/imRegister/registerOrGetImUser',
  // 获取环信用户token
  getUserLoginToken: baseUrl + 'ebook/class/common/getUserLoginToken',

  // 群聊记录保存
  saveClassGroupChatMsgHistory:
    baseUrl + 'ebook/class/common/chat/saveClassGroupChatMsgHistory',

  // 群聊记录分页获取 根据班级id或者小组id 分页获取群聊消息记录
  pageClassGroupChatMsgHistoryList:
    baseUrl + 'ebook/class/common/chat/pageClassGroupChatMsgHistoryList',

  // 根据班级id 解散班级
  dissolveClass: baseUrl + 'ebook/class/common/dissolveClass',

  // 根据据环信消息id 撤回消息清除本地记录
  messageRetraction: baseUrl + 'ebook/class/common/chat/messageRetraction',
  // #endregion
};

// 需要让外部拿到
export default config;
